<div style="width: 100%; height: 100%; position: relative;" class="cropper-bg">
    <div *ngIf="!image"  style="width: 100%; height: 100%;" class="cropper-modal"></div>
    <img *ngIf="image" #imageRef (load)="imgLoaded()" (error)="imgError()" style="height: 100%;" [src]="image" alt="">
</div>